var _path, _circle, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupplierMgt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.956 10.3615C16.9002 10.219 16.7935 10.1058 16.6591 10.0466C16.593 10.0168 16.522 10.0009 16.4502 10H13.701C13.5551 10 13.4153 10.0614 13.3122 10.1708C13.209 10.2801 13.1511 10.4284 13.1511 10.5831C13.1511 10.7377 13.209 10.886 13.3122 10.9953C13.4153 11.1047 13.5551 11.1661 13.701 11.1661H15.125L12.0514 14.4254L10.2425 12.5013C10.1913 12.4466 10.1305 12.4033 10.0635 12.3737C9.99652 12.3441 9.92466 12.3288 9.85207 12.3288C9.77949 12.3288 9.70762 12.3441 9.64062 12.3737C9.57361 12.4033 9.5128 12.4466 9.46169 12.5013L6.16264 15.9996C6.11111 16.0538 6.0702 16.1183 6.04229 16.1893C6.01437 16.2604 6 16.3366 6 16.4136C6 16.4905 6.01437 16.5667 6.04229 16.6378C6.0702 16.7088 6.11111 16.7733 6.16264 16.8275C6.21376 16.8822 6.27457 16.9256 6.34157 16.9552C6.40858 16.9848 6.48044 17 6.55303 17C6.62561 17 6.69748 16.9848 6.76448 16.9552C6.83149 16.9256 6.8923 16.8822 6.94342 16.8275L9.85207 13.7374L11.661 15.6614C11.7122 15.7161 11.773 15.7595 11.84 15.7891C11.907 15.8187 11.9788 15.8339 12.0514 15.8339C12.124 15.8339 12.1959 15.8187 12.2629 15.7891C12.3299 15.7595 12.3907 15.7161 12.4418 15.6614L15.9003 11.9882V13.4983C15.9003 13.6529 15.9582 13.8012 16.0614 13.9106C16.1645 14.0199 16.3043 14.0814 16.4502 14.0814C16.596 14.0814 16.7358 14.0199 16.839 13.9106C16.9421 13.8012 17 13.6529 17 13.4983V10.5831C16.9991 10.5069 16.9842 10.4316 16.956 10.3615Z",
    fill: "url(#paint0_linear_421_1737)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 5,
    r: 4,
    stroke: "url(#paint1_linear_421_1737)",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 15.8333C1 12.3355 3.84945 9.5 7.36443 9.5C8.84636 9.5 10.21 10.004 11.2917 10.8492",
    stroke: "url(#paint2_linear_421_1737)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_421_1737",
    x1: 11.5,
    y1: 10,
    x2: 11.5,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_421_1737",
    x1: 8,
    y1: 1,
    x2: 8,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_421_1737",
    x1: 6.14583,
    y1: 9.5,
    x2: 6.14583,
    y2: 15.8333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplierMgt);
export default __webpack_public_path__ + "static/media/SupplierMgt.19452ffca9cf561fc2be32107c814e11.svg";
export { ForwardRef as ReactComponent };